module.exports = __webpack_public_path__ + "img/flipLeft.0d1eb22d.png";